/**
 * Projects API Service
 * Handles fetching project data from the CMS
 */

import { api } from '../core/api.client';
import { ApiClientResponse } from '../core/api.types';
import { Project } from '../../types/projectType';

export class ProjectsApi {
  private readonly endpoint = 'landing-project';

  /**
   * Get all projects
   */
  async getProjects(): Promise<ApiClientResponse<Project[]>> {
    return api.get<Project[]>(this.endpoint);
  }

  /**
   * Get project by ID
   */
  async getProjectById(id: string): Promise<ApiClientResponse<Project>> {
    return api.get<Project>(`${this.endpoint}/${id}`);
  }
}

// Export singleton instance
export const projectsApi = new ProjectsApi();

// Export convenience methods
export const projects = {
  getAll: () => projectsApi.getProjects(),
  getById: (id: string) => projectsApi.getProjectById(id),
};
